import i18n from "../../../../i18n";

const toHumanLabel = (value = "") =>
	String(value)
		.replace(/^action_/, "")
		.split("_")
		.filter(Boolean)
		.map((token) => token.charAt(0).toUpperCase() + token.slice(1))
		.join(" ");

const resolveActionI18n = (actionKey = "") => {
	const titleKey = `fields.ActionsPermissions.${actionKey}.title`;
	const descriptionKey = `fields.ActionsPermissions.${actionKey}.description`;

	const title = i18n.t(titleKey);
	const description = i18n.t(descriptionKey);
	const hasTitle = title !== titleKey;
	const hasDescription = description !== descriptionKey;

	if (hasTitle || hasDescription) {
		return {
			title: hasTitle ? title : toHumanLabel(actionKey),
			description: hasDescription ? description : "",
		};
	}

	return {
		title: toHumanLabel(actionKey),
		description: "",
	};
};

export const normalizeActionLabels = (labels) => {

	if (!Array.isArray(labels)) return [];
	return labels
		.map((entry) => {
			const translated = resolveActionI18n(entry);
			return {
				key: entry,
				title: translated.title,
				description: translated.description,
			};
		})
		.filter(Boolean);
};

const ACTION_GROUPS = [
	{
		id: "users",
		matchers: ["user"],
	},
	{
		id: "roles",
		matchers: ["role"],
	},
	{
		id: "projects",
		matchers: ["projects"],
	},
	{
		id: "work_register",
		matchers: ["work_register"],
	},
	{
		id: "presences",
		matchers: ["presences"],
	},
	{
		id: "shift",
		matchers: ["shift"],
	},
	{
		id: "delegation",
		matchers: ["delegation"],
	},
	{
		id: "absence",
		matchers: ["absence"],
	},
	{
		id: "document",
		matchers: ["document"],
	},
	{
		id: "auditing",
		matchers: ["audit"],
	},
	{
		id: "notification",
		matchers: ["notification"],
	},
];

const getGroupIdByActionKey = (actionKey = "") => {

	const normalizedKey = String(actionKey).toLowerCase();
	const group = ACTION_GROUPS.find(({ matchers }) =>
		matchers.some((matcher) => normalizedKey.includes(matcher)),
	);
	return group?.id || "other";

};

export const groupActionLabelsByEntity = (actionLabels = []) => {

	if (!Array.isArray(actionLabels) || actionLabels.length === 0) return [];

	const grouped = actionLabels.reduce((acc, actionLabel) => {
		const groupId = getGroupIdByActionKey(actionLabel.key);
		if (!acc[groupId]) acc[groupId] = [];
		acc[groupId].push(actionLabel);
		return acc;
	}, {});

	return [...ACTION_GROUPS.map(({ id }) => id), "other"]
		.filter((groupId) => Array.isArray(grouped[groupId]) && grouped[groupId].length > 0)
		.map((groupId) => ({
			id: groupId,
			title: i18n.t(`fields.ActionsPermissions.groups.${groupId}.title`),
			description: i18n.t(`fields.ActionsPermissions.groups.${groupId}.description`),
			actions: grouped[groupId],
		}));
};

export const pickActionBooleanMap = (item, labelKeys = []) => {

	if (!item || typeof item !== "object") return {};

	const boolEntries = Object.entries(item).filter(([key, value]) => {
		if (typeof value !== "boolean") return false;
		if (labelKeys.length > 0 && !labelKeys.includes(key)) return false;
		return true;
	});

	if (boolEntries.length > 0) {
		return Object.fromEntries(boolEntries);
	}
	
	return {};
};

export const getAssignmentInfo = (item) => {

	const userName = `${item?.user?.first_name || ''} ${item?.user?.last_name || ''}`;
	const roleName = `${item?.role?.name || item?.role_id}`;

	if (item?.user) return { type: "user", label: userName };
	if (item?.role) return { type: "role", label: roleName };

	return {
		type: "unknown",
		label: i18n.t("pages.ManagePermissions.unknown_assignment"),
	};
};
